exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;vertical-align:baseline}a{color:#4078c0;text-decoration:none}.examples-container{padding-bottom:30px}.page-back{display:inline-block;position:absolute;top:12px;left:10px;width:40px;height:40px;text-align:center;color:#333;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.page-back i{font-size:24px;line-height:40px}.page-title{font-size:20px;margin:20px auto;text-align:center;display:block;line-height:1}.page-sub-title{font-size:16px;padding:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-ea483ea6!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/ExamplesApp.vue
// module id = 163
// module chunks = 3